export default __webpack_public_path__ + "assets/d2bf28.svg";